import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import { selectToast } from 'services/toast/redux/selectors'
import { hideToast } from 'services/toast/redux/actions'

import 'react-toastify/dist/ReactToastify.css'

const Toast = () => {
  const toastMap = useSelector(selectToast)
  const dispatch = useDispatch()

  if (!toastMap.size) {
    return null
  }

  toastMap.forEach(({ message, toastType, props }, toastId) => {
    toast[toastType](message, {
      ...props,
      toastId,
      onClose: () => {
        dispatch(hideToast(toastId))
      },
    })
  })

  return <ToastContainer />
}

export default Toast
